// extracted by mini-css-extract-plugin
module.exports = {"base":"Avatar-module-base","border":"Avatar-module-border","shadow":"Avatar-module-shadow"};